import {useMediaQuery} from "react-responsive";
export const useIsMobileOrTablet = () => {
  const isMobileOrTablet = useMediaQuery({query: "(max-width: 1080px)"});
  return {isMobileOrTablet};
};
